var map = {
	"./game.svg": "ed1a",
	"./player-basketball.svg": "35b4",
	"./player-cricket.svg": "ed50",
	"./player-football.svg": "ba7e",
	"./pointsystem.svg": "7e25",
	"./rewards.svg": "4eda",
	"./rule.svg": "ab98",
	"./sport-football.svg": "a9d1",
	"./topdecor.svg": "6604"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e1fa";